import { CalendarRangeIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import AddOfficeWorkScheduleSlotForm from '@/components/forms/add-office-work-schedule-slot-form/add-office-work-schedule-slot-form';
import { Sheet } from '@/components/ui/sheet';
import { AddOfficeWorkScheduleSlotResponse } from '@/hooks/mutations/use-add-office-work-schedule-slot';
import { OfficeDoctorAttendingItem } from '@/hooks/queries/use-get-office';
import { TONES } from '@/lib/tones';
import { selectSheetViewModel } from '../sheet.viewmodel';
import {
  SlotFormSheetActions,
  SlotFormSheetHeader,
} from '../slot-sheet/slot-form-sheet';
import {
  SlotSheetBody,
  SlotSheetContent,
} from '../slot-sheet/slot-sheet-shell';
import { selectAddOfficeWorkScheduleSlotSheetViewModel } from './add-office-work-schedule-slot-sheet.viewmodel';

export type AddOfficeWorkScheduleSlotSheetApi = {
  onClose: (
    params:
      | {
          success: true;
          data: AddOfficeWorkScheduleSlotResponse;
        }
      | {
          success: false;
        },
  ) => void;
};

export const AddOfficeWorkScheduleSlotSheet = ({
  officeId,
  doctorAttendings,
  showDoctorAttendingSelector,
  onClose,
}: {
  officeId: string;
  doctorAttendings: OfficeDoctorAttendingItem[];
  showDoctorAttendingSelector: boolean;
} & AddOfficeWorkScheduleSlotSheetApi) => {
  const { t } = useTranslation();
  const sheetViewModel = selectSheetViewModel({
    sheetName: 'AddOfficeWorkScheduleSlotSheet',
    api: {
      onClose,
    },
  });

  const viewModel = selectAddOfficeWorkScheduleSlotSheetViewModel({
    sheetViewModel,
    officeId,
    doctorAttendings,
  });

  const selectedDates = viewModel.form.watch('specificDates');

  return (
    <Sheet
      open={sheetViewModel.data.show}
      onOpenChange={sheetViewModel.api.onOpenChange}
    >
      <SlotSheetContent size="form">
        <SlotFormSheetHeader
          icon={CalendarRangeIcon}
          iconClassName={TONES.violet.text}
          title={t('add-office-work-schedule-slot-sheet.title')}
          description={t('add-office-work-schedule-slot-sheet.description')}
        />

        <SlotSheetBody className="px-6 py-5">
          <AddOfficeWorkScheduleSlotForm
            form={viewModel.form}
            doctorAttendings={doctorAttendings}
            showDoctorAttendingSelector={showDoctorAttendingSelector}
          />
        </SlotSheetBody>

        <SlotFormSheetActions
          onReset={() => viewModel.form.reset()}
          onSubmit={viewModel.api.submit}
          submitting={viewModel.data.loading}
          selectedCount={selectedDates.length}
        />
      </SlotSheetContent>
    </Sheet>
  );
};
